










































import { List } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { getId, getRouteName } from "@/config/cookies";
import { bandCar } from "@/api/interface";
import { getPlateList, relieveBand } from "@/api/factory";
@Component({
  components: {
    List,
  },
})
export default class extends Vue {
  private form: Array<Object> = [];
  private id: any = "";
  private isLoading: boolean = false;
  private loading: boolean = false;
  private finished: boolean = false;

  private onRefresh() {
    setTimeout(() => {
      this.getList();
      this.$toast("刷新成功");
      this.isLoading = false;
    }, 1000);
  }

  private onLoad() {
    setTimeout(() => {
      this.finished = true;
    }, 1000);
  }

  private mounted() {
    this.getList();
  }

  private async getList() {
    const res: any = await getPlateList({ openId: getId() });
    if (res.status == "1") {
      this.form = res.data;
    } else {
      this.$notify({ type: "warning", message: res.info });
    }
  }

  private blurBand(plateNumber: string) {
    let that = this;
    let data: any = {
      openId: getId(),
      plateNumber: plateNumber,
    };
    this.$dialog
      .confirm({
        title: "解除绑定",
        message: "是否解除当前绑定车辆",
      })
      .then(async () => {
        const result: any = await relieveBand(data);
        if (result.status) {
          that.$toast.success("解除成功");
          that.getList();
          // that.$router.replace({ name: "BandCar" });
        } else {
          that.$notify(result.info);
        }
      });
  }
}
